import "@fortawesome/fontawesome-free/js/all.js";
import { LoadingIndicator } from "./modules/loading";
import { workerFactory } from "./modules/app/WorkerFactory";
import "./FullAppConfig";
import { serverConnection } from "./modules/multiplayer/server/ServerConnectionService";
new LoadingIndicator(() => {
    return serverConnection.isServerOnline() && workerFactory.isReady();
});
try {
    void workerFactory.init(() => {
        serverConnection.readyToReceiveMessages();
    });
}
catch (error) {
    console.error(error);
}
